import { render, staticRenderFns } from "./comp_BookPageWrapper.vue?vue&type=template&id=f1be1ac0&scoped=true&"
import script from "./comp_BookPageWrapper.vue?vue&type=script&lang=js&"
export * from "./comp_BookPageWrapper.vue?vue&type=script&lang=js&"
import style0 from "./comp_BookPageWrapper.vue?vue&type=style&index=0&id=f1be1ac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1be1ac0",
  null
  
)

export default component.exports